import {storeIt, getStoredItem} from '../Utils';

export const getRankingPosition = (player) => {
    const ranking =  getStoredItem(player.game)||[];

    for(var i = 0; i < ranking.length; i++){
        if(ranking[i].timeout > player.timeout){
            return i;
        }else if(ranking[i].timeout === player.timeout){
            if(ranking[i].moves > player.moves ) return i;
        }
    }

    return ranking.length;
};

export const addToRanking = (player) =>{
    const game = player.game;
    let ranking = getStoredItem(game)||[];
    
    delete player.game;

    if(ranking !== undefined){
        const position = getRankingPosition({game, ...player});
        ranking.splice(position,0,player);
        storeIt(game, ranking);
        return true;
    }

    return false;
}; 

export const getRanking = (gameName) => {
    const ranking =  getStoredItem(gameName)||[];

    if(ranking.length > 10){
        return ranking.slice(0,10);
    }
    return ranking;
}
